var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHamburger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5649 2.56338H1.43506C0.64026 2.56338 0 1.99155 0 1.28169C0 0.571831 0.64026 0 1.43506 0H16.5649C17.3597 0 18 0.571831 18 1.28169C18 1.99155 17.3597 2.56338 16.5649 2.56338ZM18 7C18 6.29014 17.3597 5.71831 16.5649 5.71831H1.43506C0.64026 5.71831 0 6.29014 0 7C0 7.70986 0.64026 8.28169 1.43506 8.28169H16.5649C17.3597 8.28169 18 7.70986 18 7ZM18 12.7183C18 12.0085 17.3597 11.4366 16.5649 11.4366H1.43506C0.64026 11.4366 0 12.0085 0 12.7183C0 13.4282 0.64026 14 1.43506 14H16.5649C17.3597 14 18 13.4282 18 12.7183Z",
    fill: "#8995AB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.ef1606f669d22a2e4b73454f35481ba5.svg";
export { ForwardRef as ReactComponent };